import { useAuth0 } from "../auth0Wrapper"
import { useParams } from "react-router-dom"
import { getApiRegion, setApiRegion, isValidRegion } from "util/apiUtil"

export const ClasslinkCallbackPage = () => {
  const params = useParams()

  const { loginWithRedirect } = useAuth0()

  const country = params.country

  if (!isValidRegion(country)) return null

  if (country !== getApiRegion()) {
    setApiRegion(country)
    // reload entire page to make sure we are talking to the correct Auth0 instance
    window.location.reload()
    return null
  } else {
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: window.location.origin,
        connection: "ClassLink",
      },
    })
  }

  return null
}
